import store from '@/store/store'

export default {
  install (Vue) {
    document.addEventListener('visibilitychange', async () => {
      if (document.visibilityState === 'visible') {
        await store.dispatch('updateLastActiveInstance', store.getters.getActiveInstance)
        // Check whether the tab instance's token is still valid since the user might have signed out of this instance
        // in a different tab
        store.dispatch('verifyAuth')
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/plugins/page_visibility_check/index.js